import React from "react";
import useThemeConfig from "src/themes/useThemeConfig";

export default function ThemedBrandHeader(props) {
  const config = useThemeConfig();
  const ThemedBrandHeader = config.components.BrandHeader;

  return <ThemedBrandHeader {...props} />;
}
